// import React from 'react';
// import '../styles/Layout.css'; // Import your CSS file
// import Header from './commonComponent/Navbar';
// import Sidebar from './commonComponent/Sidebar';

// const Layout = ({ children }) => (
//   <div className="layout-container">
//    <div className="outer-container flex justify-center w-full">
//    <Sidebar />
//     <main className="main-content">
//       <Header />
//       {children}
//     </main>
//    </div>
//   </div>
// );

// export default Layout;


// import React, { useState } from 'react';
// import '../styles/Layout.css';
// import Header from './commonComponent/Navbar';
// import Sidebar from './commonComponent/Sidebar';

// const Layout = ({ children }) => {
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const toggleSidebar = () => {
//     setIsSidebarCollapsed(prev => !prev);
//   };

//   return (
//     <div className="layout-container">
//       <div className="outer-container flex w-full">
//       <Sidebar isCollapsed={isSidebarCollapsed} />
//         <main className="main-content flex-1">
//           <Header toggleSidebar={toggleSidebar} />
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Layout;


import React, { useState } from 'react';
import '../styles/Layout.css';
import Header from './commonComponent/Navbar';
import Sidebar from './commonComponent/Sidebar';

const Layout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const toggleSidebar = () => setIsSidebarCollapsed(prev => !prev);

  return (
    <div className="layout-container w-full h-screen flex">
      {/* Sidebar width changes with state */}
      <Sidebar isCollapsed={isSidebarCollapsed} />

      {/* Main section shrinks/grows based on sidebar width */}
      <div
  className={`transition-all duration-300 ease-in-out ms-auto overflow-x-hidden ${
    isSidebarCollapsed ? 'w-[94%]' : 'w-[84%]'
  }`}
>
  <Header toggleSidebar={toggleSidebar} isSidebarCollapsed={isSidebarCollapsed} sidebarWidth={isSidebarCollapsed ? '6%' : '16%'}/>
  <div className="p-4">{children}</div>
</div>

    </div>
  );
};

export default Layout;


